import { render } from "./municipal-map.vue?vue&type=template&id=4b41eb78"
import script from "./municipal-map.vue?vue&type=script&lang=js"
export * from "./municipal-map.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__